import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Home, Receipt, ScanBarcode, Package, UserCircle2 } from "lucide-react";

const TABS = [
  ["/my-business", "Home", Home, "tab-home", ["/my-business", "/my-branches", "/my-purchases", "/my-reports"]],
  ["/my-billing", "Billing", Receipt, "tab-billing", ["/my-billing", "/my-khata"]],
  ["/pos", "POS", ScanBarcode, "tab-pos", ["/pos"]],
  ["/my-inventory", "Inventory", Package, "tab-inventory", ["/my-inventory"]],
  ["/my-portal", "Portal", UserCircle2, "tab-portal", ["/my-portal"]],
];
const CLIENT_PREFIXES = TABS.flatMap(t => t[4]);

export function MobileTabBar() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const show = user?.role === "client" && CLIENT_PREFIXES.some(p => pathname === p || pathname.startsWith(p + "/"));
  useEffect(() => { document.body.classList.toggle("has-tabbar", !!show); return () => document.body.classList.remove("has-tabbar"); }, [show]);
  if (!show) return null;
  const tabs = user.staff_role === "cashier" ? TABS.filter(t => t[3] !== "tab-inventory") : TABS;
  return (
    <nav data-testid="mobile-tabbar" className="lg:hidden print:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur border-t border-zinc-200" style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      <div className="grid" style={{ gridTemplateColumns: `repeat(${tabs.length}, minmax(0, 1fr))` }}>
        {tabs.map(([to, label, Icon, tid, prefixes]) => {
          const active = prefixes.some(p => pathname === p || pathname.startsWith(p + "/"));
          return (
            <Link key={tid} to={to} data-testid={tid} aria-current={active ? "page" : undefined} className={`flex flex-col items-center justify-center gap-1 h-16 text-[10px] tracking-[0.12em] uppercase font-semibold transition-colors ${active ? "text-zinc-900" : "text-zinc-400 hover:text-zinc-700"}`}>
              <span className={`grid place-items-center w-9 h-7 transition-colors ${active ? "bg-zinc-900 text-white" : ""}`}><Icon size={16} /></span>
              {label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
